/**
 * Extracts user initials from a full name
 * @param fullName - The user's full name (e.g., "John Doe" or "John")
 * @returns The initials (e.g., "JD" or "J")
 */
export function getUserInitials(fullName: string | null | undefined): string {
  if (!fullName || fullName.trim().length === 0) {
    return 'U' // Default to 'U' for User if no name
  }

  const nameParts = fullName.trim().split(/\s+/)

  if (nameParts.length === 1) {
    // Single name - return first letter
    return nameParts[0].charAt(0).toUpperCase()
  }

  // Multiple names - return first letter of first and last name
  const firstInitial = nameParts[0].charAt(0).toUpperCase()
  const lastInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase()

  return `${firstInitial}${lastInitial}`
}
